/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const updatePaymentPayoutDetailConfig = {
  FIELDS: [
    {
      type: 'text',
      compProps: {
        id: 'amount',
        label: 'Amount',
        required: false,
        groupText: 'INR',
        disabled: true,
        placeholder: 'Enter amount received',
        errorText: 'Enter amount received',
      },
    },
    {
      type: 'radio',
      compProps: {
        id: 'paymentMethod',
        label: 'Payment Method',
        required: true,
        errorText: 'payment method is required',
        direction: 'horizontal',
        options: [
          {
            id: 'cash',
            label: 'Cash',
          },
          {
            id: 'cheque',
            label: 'Cheque',
          },
          {
            id: 'electronicBankTransfer',
            label: 'Electronic Bank Transfer',
          },
        ],
      },
    },
    {
      type: 'text',
      compProps: {
        id: 'instrumentNo',
        label: 'Instrument No',
        required: true,
        placeholder: 'Enter Instrument Id',
        errorText: 'Instrument Id is required',
      },
    },
    {
      type: 'datepicker',
      compProps: {
        id: 'instrumentDate',
        label: 'Instrument Date',
        required: true,
        placeholder: 'Select Date',
        errorText: 'Instrument Date is required',
      },
    },
    {
      type: 'text',
      compProps: {
        id: 'comment',
        label: 'Comments',
        required: false,
        placeholder: 'Enter your Comments',
        errorText: 'Comments is required',
      },
    },
    {
      type: 'fileDropZone',
      compProps: {
        id: 'receipt',
        label: 'Proof of attachment',
        required: false,
        maxFiles: 1,
        errorText: 'One Proof document is required',
      },
    },
  ],
  layout: [
    ['amount'],
    ['paymentMethod'],
    ['instrumentNo'],
    ['instrumentDate'],
    ['comment'],
    ['receipt'],
  ],
};
